import { object } from 'common/helpers'


export const initialState = {
  isFetching: true,
  isFetched: false,
  fragrances: {
    brands: [],
    collections: [],
    fragranceOfTheMonth: null,
  },
  makeup: {
    brands: [],
    collections: [],
    favorite: null,
  },
  personalCare: {
    products: [],
    bestseller: null,
  },
  candles: {
    products: [],
    bestseller: null,
    favorite: null,
  },
}

export const update = (state, payload) => (
  object.mergeDeep(state, payload)
)

export const setFetching = (state, payload) => (
  object.set(state, 'isFetching', payload)
)
